import { useContext } from "react"
import ScreenSizeContext from "./ScreenSizeContext"

const useScreenSize = () => useContext(ScreenSizeContext)

export default useScreenSize
